import { Injectable } from '@angular/core';
import { TrucksApiService, VehicleDto } from '@fleet-beat/api';
import { BaseDataSourceServiceV2, GetManyV2Dto, PageableListV2Dto, SnackbarService } from '@fleet-beat/core';
import { DataAutocompleteStorageParams } from '@fleet-beat/editor';

import { AuthService, CompanyStoreService } from '@fleet-beat/shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TruckListAutocompleteStorageService extends BaseDataSourceServiceV2<
  VehicleDto,
  DataAutocompleteStorageParams<object>
> {
  constructor(
    protected override snackbarService: SnackbarService,
    private authService: AuthService,
    private truksApiService: TrucksApiService,
    private companyStoreService: CompanyStoreService,
  ) {
    super(snackbarService);
  }

  protected override getData(
    data: DataAutocompleteStorageParams<{ input: string; include?: string }>,
  ): Observable<PageableListV2Dto<VehicleDto>> {
    const params: GetManyV2Dto = {
      ...data.params,
      ...data.extra,
      companyIds: this.companyStoreService.companyId,
      search: data.params.input,
    };
    return this.truksApiService.getManyV2(params, this.authService.authHeaders);
  }

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  protected override getById(id: string): Observable<VehicleDto> {
    throw new Error('Not Implemented');
  }
}
